<template>
	<div class="driver-info">
		<div class="driver-info-head">
			<div class="profile-card">
				<div class="profile-picture">
					<img :src="require('@/assets/user.png')" >
				</div>
				<div class="profile-info">
					<div class="profile-name">
						{{ current.driver_name + " (" + current.nickname + ")" }}
					</div>
					<div class="profile-document">
						<i class="fa fa-fw fa-address-card"></i> {{ current.document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") }}
					</div>
					<div class="profile-contact">
						<i class="fa fa-fw fa-phone fa-rotate-90"></i> {{ current.phone ? current.phone.replace(/^(\d{2})(\d{2})(\d{5})(\d{4})/, "+$1 ($2) $3-$4") : "Não definido" }}
					</div>
				</div>
			</div>
			<button class="driver-info-close" @click="close"><i class="fa fa-times"></i></button>
		</div>
		<div class="driver-info-body">
			<div class="driver-info-item">
				<div class="driver-info-left">Situação</div>
				<div class="driver-info-right"><span :class="current.current_status + '-color'"><i class="fa fa-fw fa-circle"></i></span>  {{ getStatus(current.current_status) }}</div>
			</div>
			<div class="driver-info-item">
				<div class="driver-info-left">Veículo {{ (current.current_total_opened == 0 ? "mais recente" : "") }}</div>
				<div class="driver-info-right">{{ current.current_license_plate ? current.current_license_plate : "Não definido" }}</div>
			</div>
			<div class="driver-info-item">
				<div class="driver-info-left">Carga {{ (current.current_total_opened == 0 ? "mais recente" : "") }}</div>
				<div class="driver-info-right">{{ (current.current_cargo ? current.current_cargo : "Não definida") }}</div>
			</div>
			<div class="driver-info-item">
				<div class="driver-info-left">Peso total</div>
				<div class="driver-info-right">{{ getWeight(current.current_total_weight) }}</div>
			</div>
			<div class="driver-info-item">
				<div class="driver-info-left">Nº entrega {{ (current.current_total_opened == 0 ? "mais recente" : "") }}</div>
				<div class="driver-info-right">{{ (current.current_delivery ? current.current_delivery : "Não definida") }}</div>
			</div>
			<div class="driver-info-item">
				<div class="driver-info-left line-height">{{ (current.current_total_opened > 0 ? "Entregas em aberto" : "Entregas mais recentes") }}</div>
				<div class="driver-info-right">
					{{ current.current_total_opened }} / {{ (current.current_total_opened + current.current_total_closed) }} 
					<button class="driver-info-button" @click="filterDelivery()"><i class="fa fa-fw fa-boxes"></i> Entregas</button>
				</div>
			</div>
			<div class="driver-info-item">
				<div class="driver-info-left line-height">{{ (current.current_total_opened > 0 ? "Entregas finalizadas" : "Rota mais recente") }}</div>
				<div class="driver-info-right">
					{{ current.current_total_closed }} / {{ (current.current_total_opened + current.current_total_closed) }} 
					<button class="driver-info-button" @click="openMap()"><i class="fa fa-fw fa-route"></i> Rota</button>
				</div>
			</div>
			<div class="driver-info-item">
				<div class="driver-info-left">Data de cadastro</div>
				<div class="driver-info-right">{{ getFormattedDate(current.created_at) }}</div>
			</div>
			<div class="driver-info-item">
				<div class="driver-info-left">Última atualização</div>
				<div class="driver-info-right">{{ getFormattedDate(current.updated_at) }}</div>
			</div>
		</div>
	</div>
</template>

<script>
const status = {
	no_delivery: "Nenhuma entrega",
	waiting: "Aguardando",
	in_progress: "A caminho",
	check_in: "Entregando",
	finished: "Finalizado",
	failed: "Não entregue",
	untracked: "Desvinculado",
};

export default {
	name: "TrackingInfo",

	props: {
		current: {
			type: Object,
			required: true,
		},
	},

	methods: {
		getFormattedDocument: function(document) {
			return document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
		},

		getFormattedDate: function(date) {
			let formatted = new Date(date);
			return formatted.toLocaleString();
		},

		getFormattedPhone: function(phone) {
			return phone.replace(/^(\d{2})(\d{2})(\d{5})(\d{4})/, "+$1 ($2) $3-$4");
		},

		getStatus: function(current_status) {
			return status[current_status];
		},

		/**
		 * Fecha o modal
		 */
		close: function() {
			this.$emit("close");
		},

		filterDelivery: async function() {
			await this.$router.push({ name: 'Delivery', params: { filter_driver: this.current.document, filter_cargo: this.current.current_cargo} });
		},

		/*openMap: async function(driver) {
			await this.$router.push({ name: 'Driver', params: { current_driver_route: driver, show_map_current_driver_route: true } });
		}*/

		openMap: function() {
			if (this.current.location) {
				this.$emit("openMap");
			} else {
				this.$notification.error("Não foi registrado a posição deste motorista.");
			}
		},

		/**
         * Retorna o peso
         * @param {number} weight peso em quilos
         * @return {string} peso em quilos ou toneladas
         */
		getWeight: function(weight) {
            let weightFormated = "";
			
            if(weight < 1000)
                weightFormated = weight.toFixed(2) + " kg";
            else
                weightFormated = (weight / 1000).toFixed(2) + " t";
            
            return weightFormated.replace(".", ",");
        },
	}
}
</script>

<style scoped>
.driver-info {
    position: absolute;
	top: 10px;
	left: 10px;
    width: 370px;
	background: #fff;
	border-radius: 2px;
	box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12) !important;
	z-index: 3;
}

.driver-info-head {
    float: left;
    width: 100%;
    /*height: 75px;*/
    overflow: hidden;
    background: #a6a6a6;
    /*padding: 10px 15px 10px 85px;*/
    /*line-height: 57px;*/
    font-size: 20px;
    font-weight: bold;
	border-top-left-radius: 2px;
	border-top-right-radius: 2px;
}

.driver-info-head > img {
    width: 55px;
    height: 55px;
    position: absolute;
    left: 15px;
    border-radius: 100%;
    background-color: #fff;
}

.profile-card {
	width: 100%;
	padding: 15px;
	float: left;
	background-color: #eee;
}

.profile-picture {
    width: 70px;
    height: 70px;
    float: left;
}

.profile-picture > img {
	width: 100%;
	height: 100%;
	background: #fff;
	border-radius: 100%;
}

.profile-info {
    float: left;
    width: calc(100% - 80px);
    padding: 0px 10px;
}

.profile-name {
	position: relative;
    font-size: 18px;
    font-weight: bold;
}

.profile-document {
    font-size: 14px;
    font-weight: bold;
    padding: 5px 0;
}

.profile-contact {
    font-size: 12px;
    font-style: italic;
    margin-bottom: 5px;
}

span.license-plate {
    float: right;
    font-weight: normal;
    background: #a6a6a6;
}

.driver-info-body {
    float: left;
    width: 100%;
	border-bottom-left-radius: 2px;
	border-bottom-right-radius: 2px;
    /*padding: 10px;*/
}

/*.driver-info-body-inner {
	float: left;
	width: 100%;
	border: 1px solid #f5f5f5;
	padding: 0 5px;
}*/

.driver-info-item {
	position: relative;
    padding: 10px 15px;
    float: left;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
}

.driver-info-left {
    width: 50%;
    float: left;
    font-size: 12px;
    font-weight: bold;
	display: grid;
    align-content: center;
}

.driver-info-right {
    width: 50%;
    float: right;
    text-align: right;
    font-size: 12px;
}
.driver-info-close {
	position: absolute;
	width: 30px;
	height: 30px;
	right: -10px;
	top: -10px;
	border-radius: 100%;
	border: none;
	background: #ddd;
}

.driver-info-loading {
	width: 100%;
	height: 400px;
	line-height: 400px;
	text-align: center;
	font-size: 70px;
	color: #ddd;
}

.driver-info-button {
	width: 80px;
	padding: 5px 10px;
	font-size: 10px;
	border: none;
	background: #222;
	color: #fff;
	margin-left: 5px;
}

.line-height {
	line-height: 23px;
}


.no_delivery-color {
	color: #aaa;
}
.waiting-color {
	color: #555;
}
.in_progress-color {
	color: #005ef7;
}
.check_in-color {
	color: #ffb300;
}
.finished-color {
	color: #008000;
}
.failed-color {
	color: #ff0000;
}
.untracked-color {
	color: #eee;
}
</style>